(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = this.querySelector('header');
      this.isTransparent = this.getAttribute('data-transparent') === 'true';
      this.promoBar = this.querySelector('.header__promo');
      this.scrolledState = null;

      // We always listen to scroll events to handle the promo bar animation
      this.onScrollHandler = () => {
        window.requestAnimationFrame(() => this.onScroll());
      };
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    onScroll() {
      const isScrolled = window.scrollY > 50;

      // Prevent redundant DOM updates on every pixel scroll
      if (this.scrolledState === isScrolled) return;
      this.scrolledState = isScrolled;

      if (this.isTransparent) {
        if (isScrolled) {
          this.header.classList.remove('text-white', 'border-transparent');
          this.header.classList.add('bg-white', 'text-black', 'border-[#EAEAEA]', 'shadow-md');
        } else {
          this.header.classList.add('text-white', 'border-transparent');
          this.header.classList.remove('bg-white', 'text-black', 'border-[#EAEAEA]', 'shadow-md');
        }
      } else {
        if (isScrolled) {
          this.header.classList.add('shadow-md');
        } else {
          this.header.classList.remove('shadow-md');
        }
      }

      // Handle Promo Bar Animation: Hidden by default, expands on scroll
      if (this.promoBar) {
        if (isScrolled) {
          this.promoBar.classList.remove('max-h-0', 'opacity-0', 'py-0', 'border-transparent');
          this.promoBar.classList.add('max-h-[100px]', 'opacity-100', 'py-3', 'border-black/10');
        } else {
          this.promoBar.classList.add('max-h-0', 'opacity-0', 'py-0', 'border-transparent');
          this.promoBar.classList.remove('max-h-[100px]', 'opacity-100', 'py-3', 'border-black/10');
        }
      }
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // Mobile Menu Functionality
  (function () {
    const mobileMenuToggle = document.getElementById('mobileMenuToggle');
    const mobileMenuClose = document.getElementById('mobileMenuClose');
    const mobileMenuDrawer = document.getElementById('mobileMenuDrawer');
    const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');

    function openMobileMenu() {
      if (!mobileMenuOverlay || !mobileMenuDrawer) return;
      mobileMenuOverlay.classList.remove('hidden');
      // small delay to allow display block to apply before animating opacity
      setTimeout(() => {
        mobileMenuOverlay.classList.remove('opacity-0');
        mobileMenuDrawer.classList.remove('-translate-x-full');
      }, 10);
      document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
      if (!mobileMenuOverlay || !mobileMenuDrawer) return;
      mobileMenuOverlay.classList.add('opacity-0');
      mobileMenuDrawer.classList.add('-translate-x-full');
      setTimeout(() => {
        mobileMenuOverlay.classList.add('hidden');
      }, 300);
      document.body.style.overflow = '';
    }

    if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openMobileMenu);
    if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
    if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', closeMobileMenu);
  })();

  // Search Functionality - AJAX Live Search
  (function () {
    const searchToggle = document.getElementById('searchToggle');
    const searchBar = document.getElementById('searchBar');
    const searchClose = document.getElementById('searchClose');
    const searchInput = document.getElementById('searchInput');
    const searchResults = document.getElementById('searchResults');
    const searchLoading = document.getElementById('searchLoading');

    let searchTimeout;

    // Toggle search bar
    searchToggle.addEventListener('click', () => {
      searchBar.classList.toggle('hidden');
      searchToggle.classList.toggle('active');
      if (!searchBar.classList.contains('hidden')) {
        searchInput.focus();
      }
    });

    // Close search bar
    searchClose.addEventListener('click', () => {
      searchBar.classList.add('hidden');
      searchToggle.classList.remove('active');
      searchResults.classList.add('hidden');
      searchLoading.classList.add('hidden');
      searchInput.value = '';
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!searchBar.contains(e.target) && !searchToggle.contains(e.target)) {
        searchBar.classList.add('hidden');
        searchToggle.classList.remove('active');
        searchResults.classList.add('hidden');
        searchLoading.classList.add('hidden');
      }
    });

    // Search input handler with debounce
    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();

      clearTimeout(searchTimeout);
      searchResults.classList.add('hidden');

      if (query.length < 2) {
        searchLoading.classList.add('hidden');
        return;
      }

      // Show loading immediately
      searchLoading.classList.remove('hidden');

      // Debounce search
      searchTimeout = setTimeout(() => performSearch(query), 300);
    });

    // Prevent form submission (Enter key)
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const query = searchInput.value.trim();
        if (query.length >= 2) {
          window.location.href = `/search?q=${encodeURIComponent(query)}&type=product,collection,page,article`;
        }
      }
    });

    // Perform AJAX search
    async function performSearch(query) {
      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(
            query
          )}&resources[type]=product,collection,page,article&resources[limit]=8`
        );
        const data = await response.json();

        searchLoading.classList.add('hidden');
        displayResults(data.resources.results, query);
      } catch (error) {
        console.error('Search error:', error);
        searchLoading.classList.add('hidden');
        searchResults.innerHTML = '<div class="p-4 text-center text-red-500 text-sm">Error loading results</div>';
        searchResults.classList.remove('hidden');
      }
    }

    // Display search results
    function displayResults(results, query) {
      let html = '';

      const products = results.products || [];
      const collections = results.collections || [];
      const pages = results.pages || [];
      const articles = results.articles || [];

      const hasResults = products.length > 0 || collections.length > 0 || pages.length > 0 || articles.length > 0;

      if (!hasResults) {
        html = `<div class="p-4 text-center text-gray-500 text-sm">No results found for "${escapeHtml(query)}"</div>`;
      } else {
        // Products
        if (products.length > 0) {
          html += '<div class="border-b border-gray-100 last:border-0">';
          html +=
            '<div class="px-4 py-2 text-xs font-bold text-gray-500 uppercase tracking-wider bg-gray-50">Products</div>';
          products.forEach((product) => {
            const price = product.price ? (product.price / 100).toFixed(2) : '';
            html += `
              <a href="${product.url}" class="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors">
                ${
                  product.image
                    ? `<img src="${product.image}" alt="${escapeHtml(
                        product.title
                      )}" class="w-12 h-12 object-cover rounded">`
                    : '<div class="w-12 h-12 bg-gray-200 rounded flex items-center justify-center text-gray-400 text-xs">No img</div>'
                }
                <div class="flex-1 min-w-0">
                  <div class="text-sm font-medium text-black truncate">${escapeHtml(product.title)}</div>
                  <div class="text-xs text-gray-500">$${price}</div>
                </div>
              </a>
            `;
          });
          html += '</div>';
        }

        // Collections
        if (collections.length > 0) {
          html += '<div class="border-b border-gray-100 last:border-0">';
          html +=
            '<div class="px-4 py-2 text-xs font-bold text-gray-500 uppercase tracking-wider bg-gray-50">Collections</div>';
          collections.forEach((collection) => {
            html += `
              <a href="${collection.url}" class="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors">
                <div class="w-8 h-8 bg-gray-200 rounded flex items-center justify-center">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                </div>
                <div class="text-sm font-medium text-black truncate">${escapeHtml(collection.title)}</div>
              </a>
            `;
          });
          html += '</div>';
        }

        // View all link
        html += `
          <a href="/search?q=${encodeURIComponent(
            query
          )}&type=product,collection,page,article" class="block px-4 py-3 text-sm text-center text-black font-medium hover:bg-gray-50 transition-colors border-t border-gray-100">
            View all results →
          </a>
        `;
      }

      searchResults.innerHTML = html;
      searchResults.classList.remove('hidden');
    }

    // Escape HTML
    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
